import React, { useMemo, Fragment } from 'react';
import { formatDate } from '../../../../utils/helpers';
import { FlexDiv } from '../../../design-system/containers';
import { TextLabel } from '../../../design-system/texts';

const DetailsField = ({ children, isLabel }) => {
    return (
        <td>
            <TextLabel lighter={isLabel} mr={isLabel ? 4 : ''}>
                {children}
            </TextLabel>
        </td>
    );
};

export default DetailsField;
